// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__QbyYE","loader":"loader_loader__SVs8d"};